module["exports"] = [
  "Slovensko"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/default_country.js
// module id = 1547
// module chunks = 0